
import { gql } from 'apollo-boost';

export const SUBMIT_INSURANCE_QUOTE = gql`
  mutation SubmitInsuranceQuote($input: SubmitInsuranceQuoteInput!) {
    insuranceQuote {
      submitInsuranceQuote(input: $input) {
        error
        success
        proposalId
      }
    }
  }
`;
